const DOCUSIGN = "docusign";

export const WORKFLOW_SERVICE = {
  DOCUSIGN
};

export const SERVICE_LABEL_MAP = {
  [WORKFLOW_SERVICE.DOCUSIGN]: "DocuSign"
};

const SIGNATURE_REQUEST = "signature_request";
export const DOCUSIGN_ACTION_LABELS = {
  [SIGNATURE_REQUEST]: "Request signature"
};
export const DOCUSIGN_ACTION_OPTIONS = [
  {
    id: SIGNATURE_REQUEST,
    label: "Request signature",
    uid: SIGNATURE_REQUEST,
    description:
      "Pre-fill and send a document to a set of receivers for signature."
  }
];

export const WORKFLOW_SERVICE_ACTION_OPTIONS = {
  [WORKFLOW_SERVICE.DOCUSIGN]: DOCUSIGN_ACTION_OPTIONS
};
export const SERVICE_ACTION_LABELS = {
  [WORKFLOW_SERVICE.DOCUSIGN]: DOCUSIGN_ACTION_LABELS
};
